import { useEffect, useState } from 'react';

import { MethodProps } from '../types';
import { useStorage } from '~Components/Storage';
import TipPicker from '~Components/TipPicker';
import useI18n from '~Translations';
import React from 'react';
import { v4 as uuid } from 'uuid';

const TimeoutTip: React.FunctionComponent<MethodProps> = ({
  amount,
  onComplete,
  onMetaChange,
}) => {
  const [storage] = useStorage();
  const [tipAmount, setTipAmount] = useState<number>();
  const { i18n } = useI18n();

  function handleTipChange(tip: number) {
    setTipAmount(tip);
    onMetaChange({
      tip: tip,
    });

    onComplete(undefined, {
      tip: tip,
      transactionId: uuid(),
    });
  }

  useEffect(() => {
    if (storage.enableTipping && tipAmount === undefined) {
      return;
    }

    // Add a default tip after 2.5 seconds if tipping is not enabled
    onMetaChange({ tip: 5000 });

    setTimeout(
      () =>
        onComplete(undefined, {
          tip: 5000,
          transactionId: uuid(),
        }),
      2500,
    );
  }, [storage.enableTipping]);

  return storage.enableTipping ? (
    <TipPicker
      paymentAmount={amount!}
      title={i18n('Payment.SelectTip')}
      onSubmit={handleTipChange}
    />
  ) : null;
};

export default TimeoutTip;
